import { Alert, Button, Container, Paper, Stack, Text, Title } from '@mantine/core';
import { Link, useSearchParams } from 'react-router';
import { useCheckoutConfirmation } from '../../controllers/use-billing.js';
import { ErrorNotice } from '../feedback/error-notice.jsx';
import { Loading } from '../feedback/loading.jsx';

export function BillingSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const confirmation = useCheckoutConfirmation(sessionId);
  return <Container size="sm" py="xl"><Paper withBorder p="xl"><Stack>
    <Title order={1}>Your subscription</Title>
    {!sessionId ? <Text>No checkout session was provided.</Text> : confirmation.isPending ? <Loading label="Confirming your subscription…" /> : confirmation.error ? <ErrorNotice error={confirmation.error} retry={() => confirmation.refetch()} /> : <Alert color="green">Your subscription is active. Thanks for supporting Page Outil!</Alert>}
    <Button component={Link} to="/dashboard">Back to dashboard</Button>
  </Stack></Paper></Container>;
}
